export default {
    GLOBAL_ONCLICK: 'global-onclick',
    REFERRAL_EXIT: 'referral-exit',
    QUICK_QUOTE_SUBMIT: 'quick-quote-submit',
    GLOBAL_LOAD: 'global-load',
    GLOBAL_OVERLAY: 'global-overlay',
    ADD_TO_GARAGE: 'add to garage',
    PREPARE_YOUR_VISIT: 'prepare your visit',
    BUY_ONLINE: 'buy online',
    VRFQ_COMPLETE: 'vrfq-complete',
    PAYMENT_ESTIMATOR_ONCLICK: 'payment-estimator-onclick',
};
